module.exports = __webpack_public_path__ + "static/media/modern-reader-4A.e6c0be2e.png";